import { useEffect, useState } from 'react';
import { useGetDownloadUrl } from '../../hooks/NetworkHooks';
import { useQParam } from '../../hooks/useQParam';
import { SuccessIcon } from '../../icons/truWeb-icons';
import './style.scss';

export const DocumentLayout = ({ requestDocument, data, uiSchema }: any) => {
  const requestKey = useQParam('requestKey');
  const [requestDocumentState, setRequestDocument] = useState([]);
  const getDownloadUrl = useGetDownloadUrl()

  useEffect(() => {
    if (requestDocumentState?.length <= 0)
      setTimeout(() => {
        handleFetchRequestDocument();
      }, 10000)
  });

  useEffect(() => {
    setRequestDocument(requestDocument)
  }, [requestDocument])

  const handleFetchRequestDocument = async () => {
    if (!requestKey || requestDocumentState?.length > 0) return false;

    const requestData = await fetch(`${window.location.origin}/wp-json/trumarket/v1/request/${requestKey}/attachment`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const requestDocumentResponse = await requestData.json();

    setRequestDocument(requestDocumentResponse.data)
  }



  const handleDownloadDocument = async (key: string[],allDocs: boolean) => {
    await getDownloadUrl(key, allDocs);
  }

  const { documentDownloadLabel, documentLabel, documentsSectionLabel } = uiSchema?.options;

  return (
    <div className="tru-layout-documents">
      <SuccessIcon />
      <h3>{documentLabel}</h3>
      <p>
        {data?.applicant?.SubmittedBy === 'broker' ?
          'Thank you for binding this motorcycle policy with us. Our underwriting team will email you the policy documents before the end of the day (or the following business day, if submitted after hours). If you have any questions please email our team at RideLife@email.bcmotorcycle.aviva.ca or call us at 1-855-275-3548 #5 in the queue.' :
          'Thank you for binding this motorcycle policy with us. We will email you a copy the policy documents before the end of the day (or the following business day, if submitted outside of regular business hours).  Included with the documents will be the invoice outlining your payment options, and the final date to pay in order to keep the policy in force. A copy of the invoice will also be mailed to you directly from Aviva. Any questions please email us at bike@megsonfitzpatrick.com or call us at 1-888-595-5212'
        }
      </p>
      <div className="document-wrapper">
        <p className='list-header'>
          <span>{documentsSectionLabel}</span>
        </p>
        <ul className='document-list'>
          {requestDocumentState?.length ? requestDocumentState?.map((doc: any) => (
            <li key={doc.key}>
              <p> {doc.name} </p>
              <span onClick={() => { handleDownloadDocument([doc.key], false) }}>{documentDownloadLabel}</span>
            </li>
          )) :
            <div className="tru-docs-loading">
              <span className="loading-anim"></span>
            </div>
          }
        </ul>
      </div>
    </div>
  );
};

